"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketRequestPaymentInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketRequestPaymentInput.js.map